 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"index": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"index": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AIChallenge":"AIChallenge","JS2Native":"JS2Native","activity~beforeSleepStory~courseDetail~courseVideo~homeActivity":"activity~beforeSleepStory~courseDetail~courseVideo~homeActivity","activity~courseDetail~courseVideo~homeActivity":"activity~courseDetail~courseVideo~homeActivity","activity~courseDetail~courseVideo~cozeBotPic":"activity~courseDetail~courseVideo~cozeBotPic","activity~courseDetail~courseVideo":"activity~courseDetail~courseVideo","activity":"activity","courseDetail":"courseDetail","courseVideo":"courseVideo","homeActivity":"homeActivity","beforeSleepStory":"beforeSleepStory","afterReading":"afterReading","allComment":"allComment","arbitraryPurchase":"arbitraryPurchase","autoRecallCourse":"autoRecallCourse","bannerReview":"bannerReview","book":"book","certificate":"certificate","comming":"comming","courseDetailQrCode":"courseDetailQrCode","courseMixSingleVideo":"courseMixSingleVideo","coursePlan":"coursePlan","courseSingleVideo":"courseSingleVideo","courseSingleVideoQrCode":"courseSingleVideoQrCode","courseVideoQrCode":"courseVideoQrCode","cozeBot~cozeBotPic~entityMedals~membershipCard~myFreeTicket":"cozeBot~cozeBotPic~entityMedals~membershipCard~myFreeTicket","cozeBot~cozeBotPic":"cozeBot~cozeBotPic","cozeBotPic":"cozeBotPic","cozeBot":"cozeBot","entityMedals":"entityMedals","membershipCard":"membershipCard","myFreeTicket":"myFreeTicket","debug":"debug","download":"download","employ":"employ","exchange":"exchange","fissionActivity~psychologyBook":"fissionActivity~psychologyBook","fissionActivity":"fissionActivity","psychologyBook":"psychologyBook","freeAudioLesson":"freeAudioLesson","gameMission":"gameMission","goldRecord":"goldRecord","goldRule":"goldRule","h5LoginPage":"h5LoginPage","h5Transfer":"h5Transfer","h5TransferFission":"h5TransferFission","help":"help","homeCombination":"homeCombination","homePage":"homePage","inviteCoupon~newBiePackage~shareGift":"inviteCoupon~newBiePackage~shareGift","inviteCoupon":"inviteCoupon","newBiePackage":"newBiePackage","shareGift":"shareGift","inviteForGift":"inviteForGift","inviteHistory":"inviteHistory","inviteShare":"inviteShare","jumpToApp":"jumpToApp","lessonGuide":"lessonGuide","luckDraw":"luckDraw","matters":"matters","middlepage":"middlepage","myGold":"myGold","newSignTask":"newSignTask","newcomerTask":"newcomerTask","openOtherApp":"openOtherApp","pandaDailyQuestion":"pandaDailyQuestion","pandaPKMatch":"pandaPKMatch","pay":"pay","privacy":"privacy","projectionHelp":"projectionHelp","readPlanCoupon":"readPlanCoupon","readingReport~writeCamp":"readingReport~writeCamp","readingReport":"readingReport","writeCamp":"writeCamp","section":"section","serviceAgree":"serviceAgree","trainingCamp":"trainingCamp","trainingReadTask":"trainingReadTask","trainingTask":"trainingTask","webLogin":"webLogin","wxAuth":"wxAuth","wxlearn":"wxlearn"}[chunkId]||chunkId) + "." + {"AIChallenge":"089e5edc","JS2Native":"fd11fdd3","activity~beforeSleepStory~courseDetail~courseVideo~homeActivity":"6a62f93f","activity~courseDetail~courseVideo~homeActivity":"44ed5268","activity~courseDetail~courseVideo~cozeBotPic":"e74c090b","activity~courseDetail~courseVideo":"24b4c3be","activity":"402f6fe1","courseDetail":"e42b50ae","courseVideo":"047a9527","homeActivity":"4a1a0457","beforeSleepStory":"bc8b6498","afterReading":"7bbfac75","allComment":"3c8fb019","arbitraryPurchase":"6512bf1e","autoRecallCourse":"1b2767ce","bannerReview":"cdff2d66","book":"9cb9a083","certificate":"79df2e89","chunk-1aa49dae":"821479a6","chunk-3f09447c":"723dd31a","chunk-5251cbe8":"db73e778","chunk-7fe69c02":"d9e6b55e","comming":"d3d29448","courseDetailQrCode":"5cfe5168","courseMixSingleVideo":"f74e3b24","coursePlan":"3c90d000","courseSingleVideo":"f03687df","courseSingleVideoQrCode":"5fa25386","courseVideoQrCode":"0887a815","cozeBot~cozeBotPic~entityMedals~membershipCard~myFreeTicket":"e4821853","cozeBot~cozeBotPic":"73a4e589","cozeBotPic":"02c86fc3","cozeBot":"b270b468","entityMedals":"4f8545ff","membershipCard":"8823024c","myFreeTicket":"fe7b3e75","debug":"d66c44cf","download":"52b553da","employ":"e3b2c37c","exchange":"404e0f01","fissionActivity~psychologyBook":"2656f7cb","fissionActivity":"df69b7f1","psychologyBook":"833246df","freeAudioLesson":"2084c12f","gameMission":"1f12b90e","goldRecord":"b57482d2","goldRule":"69637b9e","h5LoginPage":"3449697c","h5Transfer":"c27a11f7","h5TransferFission":"fc8c0483","help":"20b40267","homeCombination":"cc4f58e5","homePage":"b56e682d","inviteCoupon~newBiePackage~shareGift":"f0fcea7e","inviteCoupon":"a2906498","newBiePackage":"b479db65","shareGift":"0865295a","inviteForGift":"d6da2c03","inviteHistory":"f10139af","inviteShare":"20add990","jumpToApp":"e0a4dcc0","lessonGuide":"f0bc825e","luckDraw":"86dfbc20","matters":"278f8fd9","middlepage":"d87327e5","myGold":"8c01b215","newSignTask":"0f4516f6","newcomerTask":"762589f8","openOtherApp":"d3dcdbde","pandaDailyQuestion":"dcf0722d","pandaPKMatch":"1a033521","pay":"05e8e2ea","privacy":"065740ba","projectionHelp":"37c619d3","readPlanCoupon":"7fbe4fe6","readingReport~writeCamp":"53ea4bff","readingReport":"ce53d83d","writeCamp":"39985dff","section":"acccc312","serviceAgree":"cbf11596","trainingCamp":"6d24087f","trainingReadTask":"74d29c71","trainingTask":"94720401","webLogin":"615e3dc8","wxAuth":"aefef361","wxlearn":"2bcbaedc"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"AIChallenge":1,"JS2Native":1,"activity~beforeSleepStory~courseDetail~courseVideo~homeActivity":1,"activity~courseDetail~courseVideo~homeActivity":1,"activity~courseDetail~courseVideo~cozeBotPic":1,"activity~courseDetail~courseVideo":1,"activity":1,"courseDetail":1,"courseVideo":1,"homeActivity":1,"beforeSleepStory":1,"afterReading":1,"allComment":1,"arbitraryPurchase":1,"autoRecallCourse":1,"bannerReview":1,"book":1,"certificate":1,"chunk-1aa49dae":1,"chunk-3f09447c":1,"chunk-5251cbe8":1,"chunk-7fe69c02":1,"comming":1,"courseDetailQrCode":1,"courseMixSingleVideo":1,"coursePlan":1,"courseSingleVideo":1,"courseSingleVideoQrCode":1,"courseVideoQrCode":1,"cozeBot~cozeBotPic~entityMedals~membershipCard~myFreeTicket":1,"cozeBot~cozeBotPic":1,"cozeBotPic":1,"cozeBot":1,"entityMedals":1,"membershipCard":1,"myFreeTicket":1,"debug":1,"download":1,"employ":1,"exchange":1,"fissionActivity":1,"psychologyBook":1,"freeAudioLesson":1,"gameMission":1,"goldRecord":1,"goldRule":1,"h5LoginPage":1,"h5Transfer":1,"h5TransferFission":1,"help":1,"homeCombination":1,"homePage":1,"inviteCoupon~newBiePackage~shareGift":1,"inviteCoupon":1,"newBiePackage":1,"shareGift":1,"inviteForGift":1,"inviteHistory":1,"inviteShare":1,"jumpToApp":1,"lessonGuide":1,"luckDraw":1,"matters":1,"middlepage":1,"myGold":1,"newSignTask":1,"newcomerTask":1,"pandaDailyQuestion":1,"pandaPKMatch":1,"pay":1,"privacy":1,"projectionHelp":1,"readPlanCoupon":1,"readingReport~writeCamp":1,"readingReport":1,"writeCamp":1,"section":1,"serviceAgree":1,"trainingCamp":1,"trainingReadTask":1,"trainingTask":1,"webLogin":1,"wxAuth":1,"wxlearn":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AIChallenge":"AIChallenge","JS2Native":"JS2Native","activity~beforeSleepStory~courseDetail~courseVideo~homeActivity":"activity~beforeSleepStory~courseDetail~courseVideo~homeActivity","activity~courseDetail~courseVideo~homeActivity":"activity~courseDetail~courseVideo~homeActivity","activity~courseDetail~courseVideo~cozeBotPic":"activity~courseDetail~courseVideo~cozeBotPic","activity~courseDetail~courseVideo":"activity~courseDetail~courseVideo","activity":"activity","courseDetail":"courseDetail","courseVideo":"courseVideo","homeActivity":"homeActivity","beforeSleepStory":"beforeSleepStory","afterReading":"afterReading","allComment":"allComment","arbitraryPurchase":"arbitraryPurchase","autoRecallCourse":"autoRecallCourse","bannerReview":"bannerReview","book":"book","certificate":"certificate","comming":"comming","courseDetailQrCode":"courseDetailQrCode","courseMixSingleVideo":"courseMixSingleVideo","coursePlan":"coursePlan","courseSingleVideo":"courseSingleVideo","courseSingleVideoQrCode":"courseSingleVideoQrCode","courseVideoQrCode":"courseVideoQrCode","cozeBot~cozeBotPic~entityMedals~membershipCard~myFreeTicket":"cozeBot~cozeBotPic~entityMedals~membershipCard~myFreeTicket","cozeBot~cozeBotPic":"cozeBot~cozeBotPic","cozeBotPic":"cozeBotPic","cozeBot":"cozeBot","entityMedals":"entityMedals","membershipCard":"membershipCard","myFreeTicket":"myFreeTicket","debug":"debug","download":"download","employ":"employ","exchange":"exchange","fissionActivity~psychologyBook":"fissionActivity~psychologyBook","fissionActivity":"fissionActivity","psychologyBook":"psychologyBook","freeAudioLesson":"freeAudioLesson","gameMission":"gameMission","goldRecord":"goldRecord","goldRule":"goldRule","h5LoginPage":"h5LoginPage","h5Transfer":"h5Transfer","h5TransferFission":"h5TransferFission","help":"help","homeCombination":"homeCombination","homePage":"homePage","inviteCoupon~newBiePackage~shareGift":"inviteCoupon~newBiePackage~shareGift","inviteCoupon":"inviteCoupon","newBiePackage":"newBiePackage","shareGift":"shareGift","inviteForGift":"inviteForGift","inviteHistory":"inviteHistory","inviteShare":"inviteShare","jumpToApp":"jumpToApp","lessonGuide":"lessonGuide","luckDraw":"luckDraw","matters":"matters","middlepage":"middlepage","myGold":"myGold","newSignTask":"newSignTask","newcomerTask":"newcomerTask","openOtherApp":"openOtherApp","pandaDailyQuestion":"pandaDailyQuestion","pandaPKMatch":"pandaPKMatch","pay":"pay","privacy":"privacy","projectionHelp":"projectionHelp","readPlanCoupon":"readPlanCoupon","readingReport~writeCamp":"readingReport~writeCamp","readingReport":"readingReport","writeCamp":"writeCamp","section":"section","serviceAgree":"serviceAgree","trainingCamp":"trainingCamp","trainingReadTask":"trainingReadTask","trainingTask":"trainingTask","webLogin":"webLogin","wxAuth":"wxAuth","wxlearn":"wxlearn"}[chunkId]||chunkId) + "." + {"AIChallenge":"1a3cd3f8","JS2Native":"e2d67f0b","activity~beforeSleepStory~courseDetail~courseVideo~homeActivity":"dfe2c93b","activity~courseDetail~courseVideo~homeActivity":"5635b088","activity~courseDetail~courseVideo~cozeBotPic":"bce03a2b","activity~courseDetail~courseVideo":"fe239416","activity":"66f67134","courseDetail":"fdee6b2b","courseVideo":"78c50d66","homeActivity":"e953184d","beforeSleepStory":"c5e16344","afterReading":"4f306826","allComment":"9a926f65","arbitraryPurchase":"60a4bfec","autoRecallCourse":"deb0057b","bannerReview":"ae00a363","book":"b1b11b0a","certificate":"84a1e0d5","chunk-1aa49dae":"7b2a16a9","chunk-3f09447c":"787b4812","chunk-5251cbe8":"3d61e7e8","chunk-7fe69c02":"9daac47f","comming":"920c954b","courseDetailQrCode":"b936aea9","courseMixSingleVideo":"f473c21a","coursePlan":"8dbb375c","courseSingleVideo":"192feefe","courseSingleVideoQrCode":"d8f93b08","courseVideoQrCode":"8c21ee14","cozeBot~cozeBotPic~entityMedals~membershipCard~myFreeTicket":"c412edf5","cozeBot~cozeBotPic":"2cd7ebe4","cozeBotPic":"716876db","cozeBot":"c303daab","entityMedals":"3231e2d2","membershipCard":"43c21813","myFreeTicket":"44f750c8","debug":"8e8440f6","download":"8835f5eb","employ":"c7a344f6","exchange":"63e30db9","fissionActivity~psychologyBook":"31d6cfe0","fissionActivity":"5c0f7bd8","psychologyBook":"65780a5c","freeAudioLesson":"32734922","gameMission":"abd1e106","goldRecord":"2c6c5448","goldRule":"1cf7ce05","h5LoginPage":"ff59d519","h5Transfer":"736caa75","h5TransferFission":"1c71b349","help":"11d0cd82","homeCombination":"20a6ec16","homePage":"08e29bf7","inviteCoupon~newBiePackage~shareGift":"2e4cede8","inviteCoupon":"a41c204d","newBiePackage":"b44a059d","shareGift":"e02df74b","inviteForGift":"00a14823","inviteHistory":"91ce2a0b","inviteShare":"e84e4086","jumpToApp":"c14ba0f4","lessonGuide":"ca1e04ba","luckDraw":"81ac6b98","matters":"b1e406fb","middlepage":"df0dc40e","myGold":"c3578b16","newSignTask":"354889b3","newcomerTask":"a2fc8288","openOtherApp":"31d6cfe0","pandaDailyQuestion":"49301d61","pandaPKMatch":"010f4d9e","pay":"8b1f9b0c","privacy":"d5039e43","projectionHelp":"127c0759","readPlanCoupon":"591b1421","readingReport~writeCamp":"f1249a74","readingReport":"15e22842","writeCamp":"9ce98c3d","section":"3afa44a2","serviceAgree":"d60707ad","trainingCamp":"f39188f9","trainingReadTask":"8523500a","trainingTask":"df896685","webLogin":"35214d40","wxAuth":"4ec0a58d","wxlearn":"bef6bf15"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "//s1.igetcool.com/h5/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
